import { Skeleton } from '@optools/components/ui/skeleton';

export interface SkeletonTableProps {
  columns?: number;
  rows?: number;
}

export function SkeletonTable({ columns = 5, rows = 5 }: SkeletonTableProps) {
  return (
    <div className="grid grid-rows-[auto_1fr] overflow-hidden rounded-md border">
      <div
        className="grid gap-4 border-b px-4 py-2"
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(120px, 1fr))` }}>
        {Array.from({ length: columns }).map((_, index) => (
          <div key={index}>
            <Skeleton className="h-5" />
          </div>
        ))}
      </div>
      <div className="grid">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className="grid gap-4 border-b p-4 last:border-0"
            style={{ gridTemplateColumns: `repeat(${columns}, minmax(120px, 1fr))` }}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <div key={colIndex}>
                <Skeleton className="h-5" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
